export default __webpack_public_path__ + "static/media/of4.de00d05a.png";